import React from 'react';
import styled from 'styled-components';
import QRCode from 'qrcode.react';

import { usePageUrl } from '@/hooks/usePageUrl';
import { colors, fonts } from '@/constants/theme';

function Footer() {
  const url = usePageUrl();

  return (
    <Component>
      <QRCodeWrapper>
        <QRCodeSvg>
          <QRCode value={url} renderAs="svg" />
        </QRCodeSvg>

        <QRCodeText>
          Сканируйте <br /> QR-код, чтобы узнать больше
        </QRCodeText>
      </QRCodeWrapper>
      <Contacts>
        <Phone>+375 29 677-00-99</Phone>
        <Web>atlantm.by</Web>
      </Contacts>
    </Component>
  );
}

export default Footer;

const Component = styled.div`
  height: 122px;
  padding: 18px 17px 17px;
  border-radius: 20px 20px 0 0;
  display: flex;
`;

const QRCodeWrapper = styled.div`
  flex: 263px;
  display: flex;
  align-items: center;
  border-right: 1px solid ${colors.white};
`;

const QRCodeSvg = styled.div`
  position: relative;
  background-color: ${colors.white};
  width: 88px;
  height: 88px;
  border-radius: 8px;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 100px;
  }
`;

const QRCodeText = styled.div`
  width: 125px;
  font-family: ${fonts.GrtskTera};
  margin-left: 50px;
  font-weight: 700;
  font-size: 12px;
  line-height: 17px;
  color: ${colors.gray600};
`;

const Contacts = styled.div`
  flex: 216px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Phone = styled.div`
  font-size: 19px;
  line-height: 23px;
  color: ${colors.black};
  font-weight: 700;
`;

const Web = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: ${colors.black};
`;
